import { render, staticRenderFns } from "./AgeSet.vue?vue&type=template&id=7f95756e&scoped=true"
import script from "./AgeSet.vue?vue&type=script&lang=js"
export * from "./AgeSet.vue?vue&type=script&lang=js"
import style0 from "./AgeSet.vue?vue&type=style&index=0&id=7f95756e&prod&scoped=true&lang=css"
import style1 from "./AgeSet.vue?vue&type=style&index=1&id=7f95756e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f95756e",
  null
  
)

export default component.exports